import {createSlice} from '@reduxjs/toolkit'
import {fiasApi} from '../../api/fias-api'
import {FiasRegionInterface} from '../../../types/responses/fias-regions'

export const regionsSlice = createSlice({
    name: 'regions',
    initialState: [] as FiasRegionInterface[],
    reducers: {},
    extraReducers: builder => {
        builder.addMatcher(fiasApi.endpoints.getRegions.matchFulfilled, (state, {payload}) => {
            return payload.data
        })
    },
})

export default regionsSlice.reducer
